import { OrderType } from 'apiConnector/secondary-market/batch/model';
import { WarningIcon } from 'components/shared/PriceNext';
import { IntlKey } from 'locales';
import { FormattedMessage } from 'react-intl';

type OrderPlacedStatusProps = {
  orderType: OrderType;
  hasBackendMessage: boolean;
  isDisabled: boolean;
  btnLabel: string;
  onClick?: () => void;
};

const OrderPlacedStatus = ({ orderType, btnLabel, hasBackendMessage, isDisabled, onClick }: OrderPlacedStatusProps) => {
  const labelKey: IntlKey =
    orderType === 'ebiz-quote'
      ? 'secondary-market-batch-grid.operation.status.traded'
      : 'secondary-market-batch-grid.operation.status.order-placed';

  return (
    <div className="d-flex align-items-center gap-2 text-success h-100 px-3 flex-grow-1">
      <span className="quote-ico icon">check_circle</span>
      <span className="flex-grow-1 ">
        <FormattedMessage id={labelKey} />
      </span>
      <button className="btn p-0 text-primary text-underline" disabled={isDisabled} onClick={onClick}>
        {btnLabel}
      </button>
      {hasBackendMessage && WarningIcon}
    </div>
  );
};

export default OrderPlacedStatus;
